<template>
  <div class="filter-wrapper">
    <!-- Filter Button -->
    <button class="filter-icon-button" @click="showModal">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <path d="M7 14H21M3.5 7H24.5M10.5 21H17.5" stroke="var(--primary-color)" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>

    <!-- Modal -->
    <div v-if="showFilterModal" class="filter-modal">
      <div class="modal-header">
        <span class="modal-title">{{ $t('filters.apply_filter') }}</span>
        <span class="close-icon" @click="showFilterModal = false">{{ $t('modals.close') }}</span>
      </div>
      <div class="filter-field">
        <label>{{ $t('filters.is_active') }}</label>
        <div class="custom-select" @click="toggleDropdown('active')">
          <span>{{ selectedActive || $t('filters.select') }}</span>
          <img src="/arrowDownNew.png" alt="" />
          <ul v-if="dropdownOpen === 'active'" class="dropdown-options">
            <li @click.stop="selectOption('active', 'Yes')">{{ $t('filters.yes') }}</li>
            <li @click.stop="selectOption('active', 'No')">{{ $t('filters.no') }}</li>
          </ul>
        </div>
      </div>

      <div class="filter-field">
        <label>{{ $t('filters.roles') }}</label>
        <div class="custom-select" @click="toggleDropdown('role')">
          <span>{{ getRoleName(selectedRole) || $t('filters.select') }}</span>
          <img src="/arrowDownNew.png" alt="" />
          <ul v-if="dropdownOpen === 'role'" class="dropdown-options">
            <!-- <li @click.stop="selectOption('role', 'Admin')">Admin</li>
            <li @click.stop="selectOption('role', 'User')">User</li>
            <li @click.stop="selectOption('role', 'Guest')">Guest</li> -->

            <!-- <option disabled value="">Please select a Role</option> -->
            <li v-for="role in roles" :key="role.id" :value="role.id" @click.stop="selectOption('role', role.id)">
              {{ role.roleName }}
            </li>
          </ul>
        </div>
      </div>

      <div class="modal-actions">
        <button class="cancel-btn" @click="showFilterModal = false">{{ $t('filters.cancel') }}</button>
        <button class="apply-btn" @click="applyFilter">{{ $t('filters.apply_filter') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from '@/utils/api'

export default {
  name: 'Filter',
  props: {
    initialActive: {
      type: String,
      default: '',
    },
    initialRole: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      roles: [],
      showFilterModal: false,
      selectedActive: '',
      selectedRole: '',
      dropdownOpen: null,
      appliedFilters: {
        active: '',
        role: '',
      },
    }
  },
  mounted() {
    document.addEventListener('click', this.closeOnOutside)
    this.fetchRoles()
    // Initialize with props
    this.selectedActive = this.initialActive
    this.selectedRole = this.initialRole
    this.appliedFilters = {
      active: this.initialActive,
      role: this.initialRole,
    }
  },
  watch: {
    // Watch for prop changes
    initialActive(newVal) {
      this.selectedActive = newVal
      this.appliedFilters.active = newVal
    },
    initialRole(newVal) {
      this.selectedRole = newVal
      this.appliedFilters.role = newVal
    },
  },
  methods: {
    async fetchRoles() {
      // alert('fetchRoles')
      this.loading = true
      try {
        const res = await get('/v1/roles')
        if (res?.data?.code === 200) {
          this.roles = res.data.data.roles?.filter((role) => role.roleName !== 'SYSTEM ROLE') || []
        }
      } catch (err) {
      } finally {
        this.loading = false
      }
    },
    toggleDropdown(type) {
      this.dropdownOpen = this.dropdownOpen === type ? null : type
    },
    closeOnOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.showFilterModal = false
      }
    },
    selectOption(type, value) {
      if (type === 'active') this.selectedActive = value
      if (type === 'role') this.selectedRole = value
      this.dropdownOpen = null
    },
    applyFilter() {
      // Save the applied filters
      this.appliedFilters = {
        active: this.selectedActive,
        role: this.selectedRole,
      }

      this.showFilterModal = false
      this.$emit('filter-applied', {
        active: this.selectedActive,
        role: this.selectedRole,
      })
    },
    resetFilters() {
      this.selectedActive = ''
      this.selectedRole = ''
      this.appliedFilters = {
        active: '',
        role: '',
      }
      this.showFilterModal = false
      this.$emit('filter-applied', {
        active: '',
        role: '',
      })
    },
    showModal() {
      // Restore previously applied filters when opening modal
      this.selectedActive = this.appliedFilters.active
      this.selectedRole = this.appliedFilters.role
      this.showFilterModal = true
    },
    getRoleName(roleId) {
      const role = this.roles.find((r) => r.id === roleId)
      return role ? role.roleName : roleId
    },
  },
}
</script>

<style scoped>
.filter-wrapper {
  position: relative;
}

.filter-icon-button {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  cursor: pointer;
}

.filter-modal {
  position: absolute;
  right: 0;
  top: 40px;
  width: 503px;
  max-width: 95vw;
  background: white;
  border-radius: 12px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  padding: 24px;
  font-family: 'Archivo', sans-serif;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 11px;
  border-bottom: 1px solid #e8e8e8;
}

.modal-title {
  font-size: 24px;
  font-weight: 500;
  color: var(--primary-color);
  line-height: 18px;
  letter-spacing: 0.24px;
}

.close-icon {
  font-size: 24px;
  cursor: pointer;
}

.filter-field {
  margin-top: 22px;
}
.filter-field label {
  font-size: 18px;
  font-weight: 500;
  color: #32393e;
  margin-bottom: 6px;
  display: block;
}

.custom-select {
  position: relative;
  width: 455px;
  height: 41px;
  border: 1px solid #d1d1d1;
  border-radius: 6px;
  background: #fff;
  padding: 10px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.custom-select img {
  width: 14px;
  height: 14px;
}

.dropdown-options {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: white;
  border: 1px solid #d1d1d1;
  border-radius: 6px;
  margin-top: 4px;
  z-index: 10;
  list-style: none;
  padding: 4px 0;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.dropdown-options li {
  padding: 10px 12px;
  font-size: 14px;
  color: #32393e;
  cursor: pointer;
}

.dropdown-options li:hover {
  background: #f5f5f5;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 28px;
}

.cancel-btn {
  padding: 8px 20px;
  border: 1px solid var(--primary-color);
  background: transparent;
  color: var(--primary-color);
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}

.apply-btn {
  padding: 8px 20px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
.customHR {
  width: 100%;
  height: 2px;
  background-color: #e8e8e8;
}
</style>
